import { render, staticRenderFns } from "./EditCommunityModal.vue?vue&type=template&id=8178d7d0&scoped=true"
import script from "./EditCommunityModal.vue?vue&type=script&lang=js"
export * from "./EditCommunityModal.vue?vue&type=script&lang=js"
import style0 from "./EditCommunityModal.vue?vue&type=style&index=0&id=8178d7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8178d7d0",
  null
  
)

export default component.exports